export enum PayMinimumAmountEnum {
    PayMinimumAmount = 'MinimumPaymentDue',
    InitialPaymentDue = 'InitialPaymentDue',
    Other = 'Other'
}
